import { EventName } from '@lit/react';
import { BlocksDropdown } from 'blocks-nextjs/blocks-web-components/components/dropdown/dropdown';
import {
  BlocksChangeEvent,
  BlocksCloseEvent,
  BlocksDropdownMultiSelect,
  BlocksOpenEvent,
  BlocksScrollEndEvent,
  BlocksSelectEvent
} from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';
export const CatDropdown = createComponent({
  react: React,
  tagName: 'cat-dropdown',
  elementClass: BlocksDropdown,
  events: {
    onBlChange: 'bl-change' as EventName<BlocksChangeEvent>,
    onBlDropdownOpen: 'bl-dropdown-open' as EventName<BlocksOpenEvent>,
    onBlDropdownClose: 'bl-dropdown-close' as EventName<BlocksCloseEvent>,
    onBlSelect: 'bl-select' as EventName<BlocksSelectEvent>,
    onBlDropdownMultiSelect: 'bl-dropdown-multi-select' as EventName<BlocksDropdownMultiSelect>,
    onBlScrollEnd: 'bl-scroll-end' as EventName<BlocksScrollEndEvent>
  }
});
